import React from "react";
import PropTypes from "prop-types";
import Button from "../elements/button";
/**
 * A modal header that includes a Save and Cancel button. The button styles should not be changed.
 * If a custom header is needed in the future, consider creating a separate component.
 */

var ModalHeaderWithActions = function ModalHeaderWithActions(_ref) {
  var title = _ref.title,
      _ref$submitLabel = _ref.submitLabel,
      submitLabel = _ref$submitLabel === void 0 ? "Save" : _ref$submitLabel,
      _ref$closeModal = _ref.closeModal,
      closeModal = _ref$closeModal === void 0 ? function () {} : _ref$closeModal,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      _ref$disableSubmit = _ref.disableSubmit,
      disableSubmit = _ref$disableSubmit === void 0 ? false : _ref$disableSubmit,
      _ref$closeLabel = _ref.closeLabel,
      closeLabel = _ref$closeLabel === void 0 ? "Cancel" : _ref$closeLabel;
  return /*#__PURE__*/React.createElement("div", {
    className: "et--modal-header"
  }, /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement("div", {
    className: "et--modal-header--actions"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "simple",
    onClick: closeModal
  }, closeLabel), /*#__PURE__*/React.createElement(Button, {
    type: "default",
    disabled: disableSubmit,
    onClick: onSubmit
  }, submitLabel)));
};

ModalHeaderWithActions.propTypes = {
  title: PropTypes.string.isRequired,
  submitLabel: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disableSubmit: PropTypes.bool,
  closeLabel: PropTypes.string
};
export default ModalHeaderWithActions;